export const EducationDegree = {
  None: 'none',
  HighSchool: 'high_school',
  Bachelors: 'bachelors',
  Masters: 'masters',
  Phd: 'phd',
} as const;
export type EducationDegree = (typeof EducationDegree)[keyof typeof EducationDegree];
